import { render, staticRenderFns } from "./cameraSimple.pug?vue&type=template&id=2c8f9429&lang=pug&external"
import script from "./cameraSimple.js?vue&type=script&lang=js&external"
export * from "./cameraSimple.js?vue&type=script&lang=js&external"
import style0 from "./cameraSimple.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8f9429')) {
      api.createRecord('2c8f9429', component.options)
    } else {
      api.reload('2c8f9429', component.options)
    }
    module.hot.accept("./cameraSimple.pug?vue&type=template&id=2c8f9429&lang=pug&external", function () {
      api.rerender('2c8f9429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cameraComponent/modules/cameraSimple/index.vue"
export default component.exports